import { locale, forLocale } from "./base.js";
import { mergeRight } from "./merge.js";
function createSiteConfig(source, defaultValue) {
  return locale.chain((locale2) => {
    const [, country] = locale2.split("_");
    const config = source[country];
    if (!config) {
      if (defaultValue)
        return defaultValue;
      throw new Error(`Config for country ${country} is not defined.`);
    }
    if (!defaultValue)
      return forLocale(config);
    return forLocale(config).chain((value) => defaultValue.chain((defValue) => mergeRight(defValue, value)));
  });
}
export {
  createSiteConfig
};
//# sourceMappingURL=utils.js.map
